export default __webpack_public_path__ + "static/media/arrow3.d9c3d131.svg";